module.exports = __webpack_public_path__ + "static/media/ic_template_11.644b96ea.png";